module.exports = __webpack_public_path__ + "img/test123.61b3c4b3.png";